(() => {
  const customOptionsContaner = document.querySelector('.q-js-custom_option_container');

  if(!customOptionsContaner) {
    return
  }

  // 「カートに追加する」と「今すぐ購入」ボタンにdisabledを付与
  const buttons = {
    addCart: document.querySelector('.q-js-product-form__submit'),
    payment: document.querySelector('.shopify-payment-button__button')
  }
  const requiredContainers = customOptionsContaner.querySelectorAll('.q-js-requiredItem');

  // 必須要素が存在しない場合は処理を中断
  if(!requiredContainers.length) {
    return
  }
  // どちらのボタンも存在しない場合は処理を中断
  if(!buttons.addCart && !buttons.payment) {
    return
  }

  function setButtonsStatus(boolean){
    Object.values(buttons)
    .filter(Boolean) // falsy（null / undefined）を除外
    .forEach(button => {
      button.disabled = boolean;
      button.dataset.customOption = boolean;
    });
  };

  function hasAnyBlank(requiredContainers) {
    let fieldsBlank = [];

    requiredContainers.forEach(requiredContainer => {
      const fields = requiredContainer.querySelectorAll('input, select');
      const blanks = [...fields].filter(field => field.value.trim() === "");
      fieldsBlank.push(...blanks);
    });

    return fieldsBlank
  }

  // 実行
  setButtonsStatus(true); // カスタムオプションがある場合は、初回はDisabled

  requiredContainers.forEach(requiredContainer => {
    const field = requiredContainer.querySelector('input, select');
  
    field.addEventListener('change', () => {
      const fieldsBlank = hasAnyBlank(requiredContainers);
      if(fieldsBlank.length === 0 ) {
        setButtonsStatus(false);
      } else {
        setButtonsStatus(true);
      }
    });
  });

})();
